class AddToCartButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.handleClick.bind(this));
  }

  async handleClick(event) {
    event.preventDefault();

    if (this.hasAttribute('disabled')) return;

    const variantId = this.dataset.variantId;
    if (!variantId) return;

    this.setAttribute('disabled', 'true');

    try {
      // Step 1: Add item to cart
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/javascript',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
        }),
      });

      // Step 2: Refresh cart drawer
      const html = await fetch(`${routes.cart_url}?section_id=cart-drawer`).then((res) => res.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newDrawer = doc.querySelector('cart-drawer');
      const currentDrawer = document.querySelector('cart-drawer');

      if (newDrawer && currentDrawer) {
        currentDrawer.innerHTML = newDrawer.innerHTML;
        currentDrawer.open?.();

        // Step 3: Check updated cart state to toggle .is-empty
        const parsedState = await fetch('/cart.js').then((res) => res.json());
        currentDrawer.classList.toggle('is-empty', parsedState.item_count === 0);
      }

      // Step 4: Sync bottle deposit and free gift, if applicable
      await window.syncBottleDepositInCart?.();
      await window.syncFreeGiftInCart?.();

      // Step 5: Notify cart update
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'add-to-cart-button',
        cartData: null,
        variantId,
      });
    } catch (error) {
      console.error('Error adding to cart:', error);
    } finally {
      this.removeAttribute('disabled');
    }
  }
}

customElements.define('add-to-cart-button', AddToCartButton);
